<template>
  <v-container fluid>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="8" md="7">
        <v-card
            class="elevation-12"
            max-width="800"
            min-width="400">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-col>
              <v-toolbar-title>
                {{ $t('Список Пользователей ЭПЭ') }}
              </v-toolbar-title>
            </v-col>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear
                height="5"
                class="mb-3"
                :active="isLoading"
                color="loader"
                indeterminate />
            <general-error v-if="!!generalError" />
            <ValidationObserver ref="report" @keydown.native.enter="focusOnBtn('getReportBtn')">
              <validatable-enum-combobox
                  v-model="params.participantType"
                  clearable
                  :readonly="isLoading"
                  :values-enum="PARTICIPANT_TYPE_ENUM"
                  :label="$t('Категория участия')" />
            </ValidationObserver>
          </v-card-text>
          <v-card-actions>
            <v-btn
                id="getReportBtn"
                ref="getReportBtn"
                v-test="{ btn: 'getReport' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="getOrganizationsReport">
              {{ $t('Получить отчет') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableEnumCombobox from '@/components/reused/ui/ValidatableEnumCombobox.vue'
  import { PARTICIPANT_TYPE_ENUM } from '@/constants/enums'
  import { PARTICIPANT_TYPES } from '@/constants/business'
  import { mapActions } from 'vuex'
  import { REPORTS } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableEnumCombobox
    },
    data () {
      return {
        isLoading: false,
        PARTICIPANT_TYPE_ENUM,
        params: {
          participantType: PARTICIPANT_TYPES.PARTICIPANT
        }
      }
    },
    methods: {
      ...mapActions(REPORTS.NAMESPACE, {
        getOrganizationsReportAction: REPORTS.ACTIONS.GET_ORGANIZATIONS_REPORT
      }),
      getOrganizationsReport: async function () {
        const result = await this.$refs.report.validate()
        if (!result) {
          return
        }
        try {
          this.isLoading = true
          await this.getOrganizationsReportAction(this.params)
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
